<i18n>
{
  "fr": {
    "add-user-back-btn": "Retourner aux réglages",
    "add-user-page-title": "Ajouter un utilisateur",
    "manage-business-title": "Réglages",
    "add-user-error-user-already-in-business": "Un utilisateur avec ce courriel existe déjà dans cette entreprise.",
    "add-user-error-cant-add-system-admin": "Cet utilisateur ne peut être ajouté puisqu'il s'agit d'un administrateur système."
  },
  "en": {
    "add-user-back-btn": "Back to settings",
    "add-user-page-title": "Add a user",
    "manage-business-title": "Settings",
    "add-user-error-user-already-in-business": "A user with this email already exists in this business.",
    "add-user-error-cant-add-system-admin": "This user cannot be added because it is a system administrator."
  }
}
</i18n>

<template>
  <div class="card">
    <ui-box class="has-background-primary">
      <router-link :to="{ name: $consts.urls.URL_BUSINESS_DETAIL, query: { tab: 'users' } }" class="has-text-white">
        <span class="icon">
          <i class="fas fa-arrow-left"></i>
        </span>
        <span class="has-text-underline">{{ $t('add-user-back-btn') }}</span>
      </router-link>
      <h1 class="title is-2 has-text-weight-bold has-text-white mt-12px">{{ $t('add-user-page-title') }}</h1>
    </ui-box>
    <ui-box>
      <user-form @submit="createUser" v-model="user" :loading="loading" />
    </ui-box>
  </div>
</template>

<script>
import BusinessService from '@/services/business'

import { URL_BUSINESS_DETAIL } from '@/consts/urls'

import Breadcrumbs from '@/mixins/breadcrumbs'
import UiBox from '@/components/ui/box'
import UserForm from '@/components/businesses/user-form'
import i18n from '@/helpers/i18n'

export default {
  mixins: [Breadcrumbs],
  components: { UiBox, UserForm },
  data() {
    return {
      user: {
        firstName: '',
        lastName: '',
        email: '',
        position: '',
        type: null,
        language: i18n.userLanguage()
      },
      loading: false
    }
  },
  computed: {
    breadcrumbs() {
      return [
        {
          label: this.$t('manage-business-title'),
          url: { name: URL_BUSINESS_DETAIL, query: { tab: 'users' } }
        },
        {
          label: this.$t('add-user-page-title')
        }
      ]
    }
  },
  methods: {
    async createUser() {
      const business = await BusinessService.getCurrentBusiness()

      this.loading = true

      try {
        await this.$apollo.mutate({
          mutation: this.$options.mutation.AddUser,
          variables: {
            input: {
              businessId: business.id,
              ...this.user
            }
          }
        })

        this.$router.push({ name: URL_BUSINESS_DETAIL, query: { tab: 'users' } })
      } finally {
        this.loading = false
      }
    }
  },
  gqlErrors() {
    return {
      USER_ALREADY_IN_BUSINESS: this.$t('add-user-error-user-already-in-business'),
      CANT_ADD_SYSTEM_ADMIN: this.$t('add-user-error-cant-add-system-admin')
    }
  }
}
</script>

<graphql>
mutation AddUser($input: AddUserToBusinessInput!) {
  addUserToBusiness(input: $input) {
    user {
      id
    }
  }
}
</graphql>
